<template>
  <div>
    <div
      class="flex justify-center align-center"
      v-if="User.user.role != $roleConsts.ORG.value"
    >
      <img
        style="width: 200px;"
        :src="
          User.user_info.avatar
            ? User.user_info.avatar
            : '/static/img/avatar.png'
        "
      ></img>
    </div>
    <el-descriptions
      class="margin-top"
      title="基本信息"
      border
      :column="UI.clientWidth < 1000 ? 1 : 3"
      :labelStyle="{ width: UI.clientWidth < 1000 ? '100px' : '100px' }"
    >
      <el-descriptions-item>
        <template slot="label">
          用户名
        </template>
        {{ User.user.username }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          手机号
        </template>
        {{ User.user.mobile }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          注册ID
        </template>
        {{ User.user.user_id }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          角色
        </template>
        <el-tag size="small">{{ getRole() }}</el-tag>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['User', 'UI']),
  },

  methods: {
    getRole: function() {
      let res = [];
      for (let key in this.$roleConsts) {
        if (this.$roleConsts[key].value == this.User.user.role) {
          res.push(this.$roleConsts[key].label);
        } else if (
          this.User.user.extra_roles && this.User.user.extra_roles.includes(this.$roleConsts[key].value)
        ) {
          res.push(this.$roleConsts[key].label);
        }
      }
      return res.join('/');
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/info/defaultInfo.vue